import _ from 'lodash';
import fineTuneCheckboxesView from './fineTuneCheckboxesView.html';
import './fineTuneCheckboxesStyles.css';

// example
// <sh-fine-tune-checkboxes model="vm.search.tags" items="vm.tags" id-field="*" label-field="*" item-name="tags"></sh-fine-tune-checkboxes>
export default function fineTuneCheckboxesComponent() {
	return {
		bindings: {
			model: '=',
			items: '<',
			idField: '@?',
			labelField: '@?',
			itemName: '@',
			maxShown: '<?',
			allLabel: '@?',
			allBehavior: '@?',
		},
		controllerAs: 'vm',
		controller: fineTuneCheckboxesComponentCtrl,
		template: fineTuneCheckboxesView,
	};
}

class fineTuneCheckboxesComponentCtrl {
	constructor($scope) {
		'ngInject';
		this.maxShown = typeof this.maxShown == 'number' ? this.maxShown : 10;
		this.idField = this.idField || 'id';
		this.labelField = this.labelField || 'name';
		this.allLabel = this.allLabel || 'All';
		this.allBehavior = this.allBehavior || 'check';
		$scope.$watch('vm.items', this.sliceItems.bind(this));
		$scope.$watch('vm.filter', this.filterItems.bind(this));
	}

	hasCheckAllOption() {
		return this.allBehavior == 'check' || this.allBehavior == 'uncheck';
	}

	isAllChecked() {
		if (this.allBehavior == 'uncheck') {
			// if behavior is "uncheck", model must be empty
			return _.isArray(this.model) && this.model.length === 0;
		} else {
			// if behavior is "check", model length is equal to items length
			return (
				_.isArray(this.items) && _.isArray(this.model) && this.items.length > 0 && this.model.length === this.items.length
			);
		}
	}

	selectAll() {
		if (this.allBehavior == 'uncheck' || this.isAllChecked()) {
			// if behavior is "uncheck", always uncheck all boxes
			// if behavior is "check" only uncheck if all are checked already
			this.model.length = 0;
		} else {
			// if behavior is "check" and we are not all checked, add all items to the model
			this.model.length = 0;
			this.items.forEach(item => this.model.push(this.idField == '*' ? item : item[this.idField]));
		}
	}

	sliceItems() {
		this.hasHiddenItems = this.maxShown !== 0 && this.items && this.items.length > this.maxShown;
		if (this.hasHiddenItems) {
			this.shownItems = this.items.slice(0, this.maxShown);
			this.hiddenItems = this.items.slice(this.maxShown);
			this.filterItems();
		} else if (this.items) {
			this.shownItems = this.items;
			this.hiddenItems = [];
			this.filterItems();
		} else {
			this.shownItems = null;
			this.hiddenItems = null;
		}
	}

	filterItems(newVal, oldVal) {
		if (newVal == this.filteredBy || !_.isArray(this.items)) {
			// no change
			return;
		}
		this.filteredBy = String(newVal || '').toLowerCase();
		if (this.filteredBy === '') {
			this.filtered = this.items;
		} else if (this.labelField == '*') {
			this.filtered = this.items.filter(item => {
				return item.toLowerCase().indexOf(this.filteredBy) > -1;
			});
		} else {
			this.filtered = this.items.filter(item => {
				return item[this.labelField].toLowerCase().indexOf(this.filteredBy) > -1;
			});
		}
	}
}
